export const getPopulationPerc = (tooltipData: {
  target_audience_population_perc?: number;
  target_audience_perc?: number;
}): number => {
  return (
    tooltipData?.target_audience_perc ||
    tooltipData?.target_audience_population_perc
  );
};
